export enum PaymentAdviceStatus {
  Draft = 'draft',
  OverDue = 'overdue',
  Paid = 'paid',
  UnPaid = 'unpaid',
  Voided = 'voided',
  Overpaid = 'overpaid',
  Withdrawn = 'withdrawn',
}

export enum InvoiceStatus {
  Active = 'active',
  Voided = 'voided',
  Paid = 'paid',
  PartialPayment = 'partial_payment',
  Overpaid = 'overpaid',
  PaymentOnline = 'payment_online',
}

export enum CardTypes {
  Normal = 'normal',
  Visa = 'visa',
  Master = 'master',
  Amex = 'amex',
  UnionPay = 'union_pay',
}

export enum PaymentMethods {
  Cheque = 'cheque',
  Cash = 'cash',
  CreditCard = 'credit_card',
  NETS = 'nets',
  InterbankTransfer = 'interbank_transfer',
  Sponsorship = 'sponsorship',
  CreditNote = 'credit_note',
  QRCode = 'qr_code',
}
